import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "layout": "simple",
  "title": "Описание",
  "lead": ""
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h2: "h2",
    hr: "hr",
    p: "p",
    ..._provideComponents(),
    ...props.components
  }, {Aside, FederalMinistryGermanyLogo, LinkBlock, Title} = _components;
  if (!Aside) _missingMdxReference("Aside", true);
  if (!FederalMinistryGermanyLogo) _missingMdxReference("FederalMinistryGermanyLogo", true);
  if (!LinkBlock) _missingMdxReference("LinkBlock", true);
  if (!Title) _missingMdxReference("Title", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Title, {
      padded: true,
      children: "Описание"
    }), "\n", _jsx(_components.h2, {
      id: "scope",
      children: "SCOPE"
    }), "\n", _jsx(_components.p, {
      children: "В «SCOPE» собраны воедино административные данные, опросы домохозяйств, оценки результатов обучения и информация о финансировании образования, полученные от различных поставщиков данных, в частности Статистического института ЮНЕСКО, для изучения прогресса в достижении ЦУР 4 – глобальной цели в области образования."
    }), "\n", _jsxs(_components.p, {
      children: ["Данный сайт дополняет ", _jsx(_components.a, {
        href: "https://ru.unesco.org/gem-report/allreports",
        children: "печатное издание"
      }), " Всемирного доклада по мониторингу образования, позволяя пользователям интерпретировать данные для понимания достижений и проблем стран и регионов в решении поставленных задач. Данные доступны для совместного использования и загрузки, и заинтересованные лица могут создавать изображения и файлы данных для дальнейшего изучения, печати, использования в интернете или в презентациях."]
    }), "\n", _jsx(_components.h2, {
      id: "всемирный-доклад-по-мониторингу-образования",
      children: "Всемирный доклад по мониторингу образования"
    }), "\n", _jsxs(_components.p, {
      children: ["Всемирный доклад по мониторингу образования является независимым в редакционном отношении ежегодным докладом, который готовится и публикуется ЮНЕСКО. В соответствии с ", _jsx(_components.a, {
        href: "https://unesdoc.unesco.org/ark:/48223/pf0000245656_rus",
        children: "рамочной программой действий «Образование-2030»"
      }), ", доклад предназначен для мониторинга прогресса в области образования в рамках ЦУР и осуществления национальных и международных стратегий в области образования, с тем чтобы обеспечить подотчетность всех соответствующих партнеров за взятые обязательства."]
    }), "\n", _jsx(LinkBlock, {
      title: "Посетите сайт",
      url: "https://ru.unesco.org/gem-report/",
      variant: "gem"
    }), "\n", _jsx(_components.h2, {
      id: "цель-4-в-области-устойчивого-развития",
      children: "Цель 4 в области устойчивого развития"
    }), "\n", _jsxs(_components.p, {
      children: ["В сентябре 2015 года на Саммите Организации Объединенных Наций по устойчивому развитию в Нью-Йорке государства-члены официально приняли ", _jsx(_components.a, {
        href: "https://sustainabledevelopment.un.org/post2015/transformingourworld",
        children: "Повестку дня в области устойчивого развития на период до 2030 г"
      }), ". Повестка включает 17 целей, одна из которых – ЦУР 4 – заключается в «обеспечении инклюзивного и справедливого качественного образования и содействии расширению возможностей обучения на протяжении всей жизни для всех». ЦУР 4 включает семь задач и три средства их достижения."]
    }), "\n", _jsx(LinkBlock, {
      title: "Посмотреть задачи и связанные с ними механизмы мониторинга",
      url: "https://sustainabledevelopment.un.org/sdg4",
      variant: "sdg4"
    }), "\n", _jsx(FederalMinistryGermanyLogo, {
      lang: "en"
    }), "\n", _jsx(_components.p, {
      children: "Особая благодарность выражается Федеральному министерству образования и научных исследований Германии за партнерство и щедрый вклад в разработку сайта «Прогресс в области образования»."
    }), "\n", _jsxs(Aside, {
      children: [_jsx(_components.h2, {
        id: "контакт",
        children: "Контакт"
      }), _jsx(_components.hr, {}), _jsx(_components.p, {
        children: "Общий электронный адрес"
      }), _jsx(_components.p, {
        children: _jsx(_components.a, {
          href: "mailto:gemreport@unesco.org",
          children: "gemreport@unesco.org"
        })
      }), _jsx(_components.hr, {}), _jsx(_components.p, {
        children: "Группа"
      }), _jsx(_components.p, {
        children: "Группа по подготовке доклада ВДМО, ЮНЕСКО"
      }), _jsx(_components.hr, {}), _jsx(_components.p, {
        children: "Наш адрес:"
      }), _jsx(_components.p, {
        children: "Global Education Monitoring Report Team (GEM Report),\nUNESCO, 7 place de Fontenoy, 75352 Paris 07 SP, France"
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
